import { render, staticRenderFns } from "./ActivixSummernote.vue?vue&type=template&id=b7945d46&"
import script from "./ActivixSummernote.vue?vue&type=script&lang=js&"
export * from "./ActivixSummernote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports